import React from 'react';

export default function QtyStepper({ value, max, onChange, small = false, label }) {
  return (
    <div className={`rt-qty${small ? ' rt-qty--sm' : ''}`} role="group" aria-label={label}>
      <button type="button" aria-label="Decrease quantity" disabled={value <= 1} onClick={() => onChange(value - 1)}>−</button>
      <input inputMode="numeric" aria-label="Quantity" value={value}
        onChange={e => { const n = Number(e.target.value.replace(/\D/g, '')); if (n >= 1) onChange(Math.min(max, n)); }} />
      <button type="button" aria-label="Increase quantity" disabled={value >= max} onClick={() => onChange(value + 1)}>+</button>
    </div>
  );
}
